import React from 'react';
import { useArchReAppContext } from '@archre2/react-core';
import { Modal, Icon, ModalContent, ModalHeader } from '@archre2/react-core';

const onClose = (navigate) => navigate('/');

const Page404 = () => {
  const { navigate } = useArchReAppContext();
  return (
    <Modal onClose={() => onClose(navigate)} className="radius-xs">
      <ModalHeader onClose={() => onClose(navigate)}>
        404 - Page not found
      </ModalHeader>
      <ModalContent className="flex-column items-center padding-lg">
        <h2 className="text-semi text-center margin-b-md">
          There is nothing to be seen here....
        </h2>
        <Icon className="text-large">eye-slash</Icon>
      </ModalContent>
    </Modal>
  );
};

export default Page404;
